<template>
  <div class="page-loader" :class="{ 'show-loader' : isActive }">
    <div class="spinning-loader loader-lg active"></div>
  </div>
</template>

<script>
export default {
  name: 'PageLoader',
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  components: {
  },
  created () {},
  computed: {},
  methods: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.page-loader{
  display: none;
  overflow: hidden;
  justify-content: center;
  align-items: center;
  position: fixed;
  height: 100vh;
  width: 100vw;
  top: 0px;
  left: 0px;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.8);
  &.show-loader{
    display: flex;
  }
}
</style>
